<!-- Sub-section: inputs collapsed, current value next to it -->
<div class="d-flex justify-content-between align-items-center" [class.avs-fuelcell-stale]="!isEditable">
    <div class="d-flex align-items-center flex-wrap">
        <ng-container *ngIf="!isUnavailable; else unavailableTitle">
            <div class="d-flex align-items-center avs-fuelcell-collapse-toggle" role="button"
                [attr.aria-expanded]="isSettingExpanded" title="Einstellung ein- oder ausklappen"
                (click)="isSettingExpanded = !isSettingExpanded">
                <img height="12" alt="" [src]="isSettingExpanded ? 'assets/icons/caret-down.svg' : 'assets/icons/caret-right.svg'">
                <span class="ms-1">Externer Tanksensor</span>
            </div>
            <span class="ms-3">{{ statusText }}</span>
        </ng-container>
        <ng-template #unavailableTitle>
            <span>Externer Tanksensor</span>
            <span class="ms-3 text-secondary">für dieses Gerät nicht verfügbar</span>
        </ng-template>
    </div>
    <div class="d-flex align-items-center">
        <span *ngIf="information" class="text-danger small me-2">{{ information }}</span>
        <img class="avs-icon-edit ms-2" role="button" height="20" src="assets/icons/arrow-clockwise.svg"
            alt="Aktualisieren" title="Aktualisieren" (click)="load()">
    </div>
</div>
<p *ngIf="isBusy" class="text-secondary small mb-1">{{ busyMessage }}</p>
<div class="d-flex justify-content-between align-items-center mt-1" *ngIf="!isUnavailable && isSettingExpanded"
    [class.avs-fuelcell-stale]="!isEditable">
    <mat-slide-toggle color="primary" [(ngModel)]="ignoreExternalFuelSensor" [disabled]="!isEditable">
        Meldung des externen Tanksensors ignorieren
    </mat-slide-toggle>
    <button class="btn btn-outline-success rounded-0 ms-2" type="button"
        [disabled]="!isEditable || !isChanged" (click)="onSaveClicked()">Speichern</button>
</div>
